// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const badgesApi = baseApi.injectEndpoints({
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    addBadge: builder.mutation({
      query: (data) => {
        return {
          url: "badge",
          method: "POST",
          body: data,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllBadges: builder.query({
      query: () => {
        return {
          url: "badge",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Badges"],
    }),
    updateBadge: builder.mutation({
      query: ({ formData, slug }) => {
        return {
          url: `badge/${slug}`,
          method: "PATCH",
          body: formData,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["Badges"],
    }),
    // deletePostReport: builder.mutation({
    //   query: (id) => {
    //     return {
    //       url: `post-report/${id}`,
    //       method: "DELETE",
    //       // body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         authorization: `Bearer ${getToken()}`,
    //       },
    //     };
    //   },
    //   // invalidatesTags: ["Posts"],
    // }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddBadgeMutation,
  useGetAllBadgesQuery,
  useUpdateBadgeMutation,
  // useDeletePostReportMutation,
} = badgesApi;
